import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { VIDEOS_FEATURE_KEY } from './keys';
import { videosReducer } from './reducers/videos.reducer';
import { VideosEffects } from './effects/videos.effects';

export const videosStoreProviders = [provideState(VIDEOS_FEATURE_KEY, videosReducer), provideEffects(VideosEffects)];

export { VideosFacade } from './facades/videos.facade';
export { videoCleanup } from './guards/cleanup.guard';
export { Video } from './models';
